<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  color: {
    type: String,
    default: 'slate',
    validator: value =>
      ['blue', 'ruby', 'amber', 'slate', 'teal'].includes(value),
  },
  actionLabel: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['action']);

const bannerClass = computed(() => {
  const classMap = {
    slate: 'bg-n-slate-3 border-n-slate-4 text-n-slate-11',
    amber: 'bg-n-amber-3 border-n-amber-4 text-n-amber-11',
    teal: 'bg-n-teal-3 border-n-teal-4 text-n-teal-11',
    ruby: 'bg-n-ruby-3 border-n-ruby-4 text-n-ruby-11',
    blue: 'bg-n-blue-3 border-n-blue-4 text-n-blue-11',
  };

  return classMap[props.color];
});
</script>

<template>
  <div
    class="flex min-w-0 flex-wrap items-center justify-between gap-2 rounded-xl border px-3 py-2 text-sm"
    :class="bannerClass"
  >
    <div class="min-w-0 grow basis-48 break-words">
      <slot />
    </div>
    <div
      v-if="$slots.actions || actionLabel"
      class="flex max-w-full flex-wrap items-center gap-1 [&_button]:max-w-full"
    >
      <slot name="actions">
        <Button
          v-if="actionLabel"
          type="button"
          size="sm"
          variant="faded"
          :color="color"
          :label="actionLabel"
          @click="emit('action')"
        />
      </slot>
    </div>
  </div>
</template>
